/* globals functionality, login, rulesFlow, views, showModalError, showModalConfirm */
import React, {
    useState,
    useEffect,
  } from "react";
  import styled from "styled-components";
  import Request from "common/Request";
  import DataTable, { Column } from "common/DataTable";
  import { safeStr } from "common/api";
  
  const doesNothing = () => {};
  
  const returnView = "viewRulesMonitor";

  const warningRE = new RegExp("%WARN-EINVAL:\\s(.*)");

  export const handleWarnings = (input) => {
    const match = input.match(warningRE);
    if (match !== null) {
      const [_all, message] = match;
      throw message;
    }
    return input;
  };
  
  
  /*****************************************************
   * Radius-Rest Policies View
   * ****************************************************/
  export const SubscriberMonitorPoliciesTable = () => {
    const [request, setRequest] = useState(null);
  
    const doRequest = () => ifCl.run("show policy monitor").then(response => ({response}))
  
    const doLoad = () => {
      setRequest(doRequest());
    };
  
    useEffect(() => {
      doLoad();
    }, []);
  
    return request === null ? null : (
      <div className="row clearfix">
        <div className="body table-responsive">
          <Request during={request}>
            {(result) => <ShowPolicies {...result} reload={doLoad} />}
          </Request>
        </div>
      </div>
    );
  };
  
  const notFoundRE = /%ERR-ENOENT: Cannot find "(.*)" policy/;
  
  /*****************************************************
   * Policies Table
   * ****************************************************/
  
  const monitorPolicyActions = ([name, ...row], whenDone) => [
    {
      id: "edit-config",
      label: "Edit",
      icon: "edit",
      onClick: (_value, [name, _id, _source, ..._rest]) =>
        doEditPolicy(name, whenDone),
    },
    ...( 
      name === 'monitor-default'
        ? []
        : [{
            id: "delete-config",
            label: "Delete",
            icon: "delete",
            onClick: (_value, [name, _id, _source, ..._rest]) =>
              doDeletePolicy(name, whenDone),
          }]
    )
  ];
  const TableContainer = styled.div`
    width: 100%;
    overflow: auto;
    margin-top: -20px;
  `;
  
  const ShowPolicies = ({ response, reload = doesNothing }) => 
    <TableContainer>
      <DataTable
        pageLength={50}
        exportAsCSV={true}
        content={response}
        columns={[
          Column.Text({
            label: "NAME",
            idx: 0,
            cellClassName: "hyperlink-text",
            onClick: (name) => doEditPolicy(name, reload),
          }),
          Column.Text({
            label: "UDR",
            idx: 3,
          }),
          Column.Actions({
            label: "ACTIONS",
            idx: 0,
            are: (source, row) => monitorPolicyActions(row, reload),
            colClassName: "text-center action",
            cellClassName: "hides-content-to-operators",
          }),
        ]}
      />
    </TableContainer>
  
  const doEditPolicy = (policy) => {
    globalNavigate("viewPolicyMonitorEdit", {returnView: "viewRulesMonitor", tab:2, policy})
  };
  
  const doDeletePolicy = (name, whenDone = doesNothing) =>
    showModalConfirm(
      `Remove "${name}" policy?`,
      'WARNING: All policy data will be lost and all subscribers assigned to this policy will be reassigned to a default rate policy following the BQN configured rules (normally default policy is "rate-default").',
      "delete_forever",
      () => {
        ifCl
          .run(`clear policy monitor ${safeStr(name)}`)
          .then(handleWarnings)
          .then(whenDone)
          .catch((error) => showModalError(error));
      }
    );
  
  
